import { render, staticRenderFns } from "./ListaNomina.vue?vue&type=template&id=663c1954&"
import script from "./ListaNomina.vue?vue&type=script&lang=js&"
export * from "./ListaNomina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports